import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    document.documentElement.style.setProperty('--fixed-header-height', `${this.element.offsetHeight}px`)
  }
}
